import { useCallback } from "react";
import { MktVersionTypes } from "../components/mkt/mktVersionUtils";

/**
 * Google Ads 이벤트 타입
 */
export type GtagEventType =
  | "ViewContent"
  | "InitiateCheckout"
  | "Purchase"
  | "CompleteRegistration";

/**
 * 버전별 이벤트 타입별 label 매핑
 * 형식: AW-10862597581/{label}
 */
const EVENT_LABELS: Record<string, Record<GtagEventType, string>> = {
  v3: {
    ViewContent: "AW-10862597581/psVqCN-889IbEM2r2Lso",
    InitiateCheckout: "AW-10862597581/FAlwCMDW89IbEM2r2Lso",
    Purchase: "AW-10862597581/0gHvCPCh-9IbEM2r2Lso", // 구매완료_v3
    CompleteRegistration: "AW-10862597581/tUKSCJCd79IbEM2r2Lso",
  },
  v4: {
    ViewContent: "AW-10862597581/XANlCPiU9NIbEM2r2Lso",
    InitiateCheckout: "AW-10862597581/xT-UCK6P8NIbEM2r2Lso",
    Purchase: "AW-10862597581/K-jaCOWc8NIbEM2r2Lso",
    CompleteRegistration: "AW-10862597581/8zVjCMu-_tIbEM2r2Lso",
  },
};

interface GtagConversionParams {
  transactionId?: string;
  value?: number;
  currency?: string;
  email?: string;
}

/**
 * Google Ads 전환 이벤트를 전송하는 훅
 */
export default function useGtagConversion() {
  const trackEvent = useCallback(
    (
      eventType: GtagEventType,
      version: MktVersionTypes,
      params?: GtagConversionParams
    ) => {
      if (!window.gtag) {
        console.warn("[gtag] gtag is not initialized");
        return;
      }

      const label = EVENT_LABELS[version]?.[eventType];
      if (!label) {
        console.warn(
          `[gtag] No label found for event ${eventType} version ${version}`
        );
        return;
      }

      const eventParams: any = {
        send_to: label,
        transaction_id: params?.transactionId ?? "",
        value: params?.value,
        currency: params?.currency,
      };

      if (
        params?.email &&
        (eventType === "CompleteRegistration" ||
          eventType === "InitiateCheckout" ||
          eventType === "Purchase" ||
          eventType === "ViewContent")
      ) {
        eventParams.user_data = {
          email: params.email,
        };
      }

      window.gtag("event", "conversion", eventParams);

      console.log(`[gtag] Tracked ${eventType} (${version}):`, label, params);
    },
    []
  );

  return trackEvent;
}
